<template>
  <div class="color-palette-select">
    <aha-dropdown-v2 :customClass="''">
      <aha-dropdown-trigger-v2>
        <ColorPaletteSelectItem :colorPalette="selectedItem" />
      </aha-dropdown-trigger-v2>
      <aha-dropdown-menu class="overflow-auto max-h-24">
        <ColorPaletteSelectItem
          v-for="colorPalette in colorPalettes"
          :key="colorPalette.id"
          :colorPalette="colorPalette"
          @selectcolorPalette="selectItem"
        >
        </ColorPaletteSelectItem>
      </aha-dropdown-menu>
    </aha-dropdown-v2>
  </div>
</template>

<script>
import ColorPaletteSelectItem from '@/components-v2/presentation-editor/side-right/right-nav/ColorPaletteSelectItem.vue'

export default {
  name: 'ColorPaletteSelect',
  components: {
    ColorPaletteSelectItem,
  },
  props: {
    selectedColorPaletteId: {
      type: String,
      default: null,
    },
    colorPalettes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedItem() {
      return this.colorPalettes.find((colorPalette) => colorPalette.id === this.selectedColorPaletteId)
    },
  },
  methods: {
    selectItem(colorPalette) {
      this.$emit('selectColorPalette', colorPalette)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
